export const GLOBAL_MENU_LINKS = [
  {
    category: 'ランキング',
    links: [
      { name: 'パチンコ', url: '/K007/index.html' },
      { name: 'スロット', url: '/K007/index.html?ps=1' },
    ],
  },
  {
    category: '導入後推移',
    links: [
      { name: 'パチンコ', url: '/K012/index.html' },
      { name: 'スロット', url: '/K012/index.html?ps=1' },
    ],
  },
  // FIXME フェーズ2で追加
  // {
  //   category: '中古相場',
  //   links: [
  //     {name: 'パチンコ', url: '#'},
  //     {name: 'スロット', url: '#'},
  //   ],
  // },
  {
    category: '機種平均',
    links: [
      { name: '設定別', url: '/K013/index.html' },
      { name: 'レート別比較', url: '/K014/index.html' },
      { name: '期間別', url: '/K011/index.html' },
      { name: '地区別', url: '/K008/index.html' },
      { name: '損益分岐割数別', url: '/K009/index.html' },
      { name: 'ランク別', url: '/K010/index.html' },
    ],
  },
  {
    category: '業界平均',
    links: [
      { name: 'レート別', url: '/K002/index.html' },
      { name: 'タイプ別', url: '/K002/index.html?typeFlg=1' },
      { name: '地区別', url: '/K003/index.html' },
      { name: '損益分岐割数別', url: '/K004/index.html' },
      { name: 'ランク別', url: '/K005/index.html' },
      { name: '設置台数別', url: '/K006/index.html' },
    ],
  },
];

export default GLOBAL_MENU_LINKS;
